import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type Theme = 'light' | 'dark';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly theme = new BehaviorSubject<Theme>('dark');

  get theme$(): Observable<Theme> {
    return this.theme.asObservable();
  }

  constructor() {}

  setTheme(prefersDark: boolean): void {
    this.theme.next(prefersDark ? 'dark' : 'light');
  }
}
